import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart: [],
  totalCount: 0,
  checkoutUrl: "",
  showMiniCart: false,
};

export const cartSlice = createSlice({
  name: "cartData",
  initialState,
  reducers: {
    toggleMiniCart: (state) => {
      state.showMiniCart = !state.showMiniCart;
    },
    setCart: (state, action) => {
      state.cart = action.payload;
      state.totalCount = state.cart.map((item) => Number(item.quantity)).reduce((a, b) => a + b, 0);
    },
    setCheckoutUrl: (state, action) => {
      state.checkoutUrl = action.payload ?? "#";
    },
    clearCart: () => initialState,
  },
});

export const { setCart, clearCart, setCheckoutUrl, toggleMiniCart } = cartSlice.actions;

export default cartSlice.reducer;
